/**
 * Trust Strip - Proof indicators below hero
 * Shows credibility without being generic
 */

import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

interface TrustItem {
  label: string;
  value?: string;
}

const trustItems: TrustItem[] = [
  { label: 'Built from real sales execution', value: 'EME' },
  { label: 'Setup in minutes', value: 'No training required' },
  { label: 'Cancel anytime', value: 'No lock-in' },
];

export function TrustStrip() {
  return (
    <motion.div
      className="flex flex-wrap items-center justify-center gap-[var(--gap-comfortable)] text-xs md:text-sm text-muted-foreground tracking-[var(--tracking-normal)]"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8 }}
    >
      {trustItems.map((item, index) => (
        <motion.div
          key={index}
          className="flex items-center gap-2"
          initial={{ opacity: 0, x: -8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.9 + index * 0.1 }}
        >
          <Check className="w-3.5 h-3.5 text-primary/60" />
          <span>
            {item.label}
            {item.value && (
              <span className="text-foreground/80 font-medium ml-1">{item.value}</span>
            )}
          </span>
        </motion.div>
      ))}
    </motion.div>
  );
}

